import chroma from 'chroma-js';
import {BORDER_WIDTH} from '../../../spotlight/libs';
import {Rect} from '../../types';

interface HighlightRectProps {
  rect: Rect;
  scale?: number;
}

export const HighlightRect = ({rect, scale = 1}: HighlightRectProps) => {
  const strokeColor = rect.color || '#e43897';
  const fill = chroma(strokeColor).alpha(0.1).hex();

  const strokeWidth = (BORDER_WIDTH / scale) * 0.75;
  const borderRadius = Math.max(BORDER_WIDTH / scale, 2.5) * 1.5;

  const renderRect = (strokeDasharray?: string) => {
    return (
      <svg
        className="absolute size-full"
        style={{filter: 'drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1))'}}
      >
        <rect
          x="3"
          y="3"
          width="calc(100% - 6px)"
          height="calc(100% - 6px)"
          fill={fill}
          stroke={strokeColor}
          strokeDasharray={strokeDasharray}
          strokeWidth={strokeWidth}
          rx={borderRadius}
        />
      </svg>
    );
  };

  if (rect.active) {
    return (
      <div className="absolute size-full">
        {renderRect('4 4')}
        <div className="absolute top-[-2px] left-[-2px] size-2.5 cursor-nw-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-[-2px] left-1/2 size-2.5 -translate-x-1/2 cursor-n-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-[-2px] right-[-2px] size-2.5 cursor-ne-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-1/2 right-[-2px] size-2.5 -translate-y-1/2 cursor-e-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute bottom-[-2px] left-[-2px] size-2.5 cursor-sw-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute bottom-[-2px] left-1/2 size-2.5 -translate-x-1/2 cursor-s-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute right-[-2px] bottom-[-2px] size-2.5 cursor-se-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-1/2 left-[-2px] size-2.5 -translate-y-1/2 cursor-e-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
      </div>
    );
  }

  return renderRect();
};
